import { createSlice } from "@reduxjs/toolkit";
import { getUserDetails } from "../profile/profileSlice";

export const defaultTourStatus = {
    'dashboard': false,
    'flavorPortal': false,
    'productionSheets': false,
    'digitalRecipePortal': false,
    'digitalMenuBoard': false,
    'digitalDriveThruBoard': false,
    'hoursOfOperation': false,
    'vendorPortal': false
}

const initialState = {
    userFirstTime : true,
    steps         : [],
    run           : false,
    showProgress  : false,
    currentTourComponent   : "",
    stepIndex: 0,
    continuous : true,
    psTourSkipped : false,
    psTourCompleted : false,
    tourStatus: defaultTourStatus,
    tourSkipped: defaultTourStatus,
    fetchedTourStatus: false
};

export const userOnboardingSlice = createSlice({
    name: "userOnboarding",
    initialState,
    reducers: {
        clearTourState: (stateVal) => initialState,
    
        updateSteps: (state, action) => {
          const newSteps = [...action.payload];
          state.steps = newSteps;
        },

        setStepIndex: (state, action) => {
            state.stepIndex = action.payload;
        },

        runTour: (state, action) => {
            state.run = true;
            state.currentTourComponent = action.payload;
            if (state.currentTourComponent === "productionSheets") {state.psTourSkipped = false}
            return state;
        },

        stopTour: (state) => {
            state.run = false;
            state.stepIndex = 0;
            return state;
        },

        showTourProgress: (state) => {
            state.showProgress = true;
            return state;
        },

        hideTourProgress: (state) => {
            state.showProgress = false;
            return state;
        },

        continuousTour: (state) => {
            state.continuous = true;
            return state;
        },

        nonContinuosTour: (state) => {
            state.continuous = false;
            return state;
        },

        skipPsTour: (state) => {
            state.psTourSkipped = true
            return state;
        },

        completePsTour: (state) => {
            state.psTourCompleted = true
            return state;
        },

        skipTour: (state, action) => {
            let newSkipTourStatus = {...state.tourSkipped}
            newSkipTourStatus[state.currentTourComponent] = true;
            state.tourSkipped = newSkipTourStatus;
            return state;
        },
        updateTourStatus: (state, action) => {
            return { ...state, tourStatus: action.payload };
        },
    
      },
      extraReducers: (builder) => {
          builder
              .addCase(getUserDetails.pending, (state) => { })
              .addCase(getUserDetails.fulfilled, (state, action) => {
  
                  return { ...state, tourStatus: action.payload?.tourStatus, fetchedTourStatus: true };
              })
              .addCase(getUserDetails.rejected, (state, action) => { });
      },
});

export const { clearTourState, updateSteps, setStepIndex, runTour, stopTour, showTourProgress, hideTourProgress,
    continuousTour, nonContinuosTour, skipPsTour,completePsTour, skipTour, updateTourStatus} = userOnboardingSlice.actions;
export default userOnboardingSlice.reducer;